
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/construction",
      function () {
        return require("private-next-pages/companies/construction/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/construction"])
      });
    }
  